import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AnexoTableProps } from '../../../interfaces/props/Anexo/AnexoTableProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import './styles.css';
import { sxButtonText, sxTable } from './sxProps';

const AnexosTable: React.FC<AnexoTableProps> = ({ data, openAnexo }) => {

  
  const accessibility = useAccessibility();

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    ...{
      fontFamily: 'Unimed-Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
    },
    ...accessibility.textStyleAccessibility,
    color: accessibility.contrastMode ? 'white' : '#4C4C4C'
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#F9F9F9'
    },
  }));

  return (
    <TableContainer className='container-table' sx={sxTable} component={Paper} style={accessibility.contrastBorderAccessibility}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell><b>Data</b></StyledTableCell>
            <StyledTableCell align="left"><b>Solicitante</b></StyledTableCell>
            <StyledTableCell align="left"><b>Anexo</b></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((row, index) => (
            <StyledTableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <StyledTableCell component="th" scope="row">
                {row.dtHoraInclusao}
              </StyledTableCell>
              <StyledTableCell align="left">{row.nomePrestador}</StyledTableCell>
              <StyledTableCell align="left">
                <Button 
                  onClick={() => openAnexo(row.idAnexoProntu)} 
                  variant='text' sx={{ ...sxButtonText }} 
                  style={accessibility.textStyleAccessibility}
                  aria-label={`visualizar documento de ${row.nomePrestador} em ${row.dtHoraInclusao}`}
                >
                  <Typography style={accessibility.textStyleAccessibility} sx={sxButtonText}>visualizar</Typography>
                </Button>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default AnexosTable;